/**
 * How a workout's data should be read and displayed.
 *
 * This lives on its own, apart from `WorkoutLoaderService`, because it is a
 * plain enum that many modules need while the service itself drags in Angular
 * and the whole exercise-database chain. Importing the enum from the service
 * pulls all of that in — which a plain mocha unit test cannot load. The service
 * re-exports it, so every existing `from 'services/workout-loader.service'`
 * import keeps working.
 */
export enum WorkoutLoadMode {
  // Workouts that are in the past cannot be "performed" again, but they can be viewed and edited
  Past = -1,
  // The most current workout - the one that should be performed now.
  // It doesn't necessarily have to be today's workout, because users are free to log workouts a bit in the past
  Current = 0,
  // Workouts that are ahead of the current, they are displayed in a simplified way, but can be made current on user demand.
  SoftFuture = 1,
  // Workouts that are in the future, they are displayed in a simplified way, and cannot be performed or edited.
  HardFuture = 2,
  // showing workout template when accessed from plan page, not an actual workout
  // this is put as >Current, because it is displayed very similar to the Future mode
  Template = 3,
  // if we didn't determine the mode yet, this is >Template so it would render as template in case we get stuck there
  Unknown = 999,
}
